import {SectionWrapper} from "shared/Styles/Wrappers";
import styled           from "styled-components";

export const Container = styled.div`
    padding: 124px 0;
    background-color: ${({color}) => (color ? color : "#fff")};
    margin-top: -1px;
    margin-bottom: -1px;
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding: 64px 0;
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding: 36px 0;
    }
`;

export const Wrapper = styled(SectionWrapper)`
    max-width: ${({content}) => (content ? content + 'px' : "1400px")};

    .gatsby-image-wrapper {
        width: 100%;
        height: auto;
    }
`;
